import { render } from "./CadastroMensagensPadraoView.vue?vue&type=template&id=53d97716&scoped=true"
import script from "./CadastroMensagensPadraoView.vue?vue&type=script&lang=js"
export * from "./CadastroMensagensPadraoView.vue?vue&type=script&lang=js"

import "./CadastroMensagensPadraoView.vue?vue&type=style&index=0&id=53d97716&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d97716"]])

export default __exports__